var constants = require('../constants');
var api = require('../../../utils/api');
var commonActions = require('../../common/actions/common');
var utils = require('../specialistsUtils');

var SpecialistsActions = (function(){

    var _requestSpecialists = function() {
        return {
            type: constants.REQUEST_SPECIALISTS
        };
    }

    var _receiveSpecialists = function(data, postalCode) {
        return {
            type: constants.RECEIVE_SPECIALISTS,
            data: data.providers || [],
            postalCode: postalCode || ""
        };
    }

    var _requestSpecialistsFailure = function() {
        return {
            type: constants.REQUEST_SPECIALISTS_FAILURE
        };
    }

    var _searchSpecialists = function(postalCode) {
        return function (dispatch) {
            dispatch(_clearSpecialists());
            utils.validate(postalCode)
                .then(function(result) {
                    if (result === true) {
                        dispatch(commonActions.clearGenericError());
                        dispatch(_requestSpecialists());
                        return api.get('/proxy/v1/providers?postalcode=' + postalCode).then(function (data) {
                            return dispatch(_receiveSpecialists(data, postalCode));
                        }).catch(function(error){
                            dispatch(_requestSpecialistsFailure());
                            if(error.response){
                                dispatch(commonActions.setGenericResponseError('', error.response));
                            }else{
                                dispatch(commonActions.setGenericError('', error.message));
                            }
                        });
                    } else {
                        dispatch(commonActions.setGenericError(result));
                    }
                });
        };
    }

    var _clearSpecialists = function(token){
        return {
            type: constants.CLEAR_SPECIALISTS
        };
    }

    var _clearPostalCode = function(){
        return {
            type: constants.CLEAR_POSTAL_CODE
        };
    }

    var _clearSpecialistsError = function(){
        return {
            type: constants.CLEAR_SPECIALISTS_ERROR
        };
    }

    return {
        searchSpecialists: _searchSpecialists,
        clearSpecialists: _clearSpecialists,
        clearPostalCode: _clearPostalCode,
        clearSpecialistsError: _clearSpecialistsError
    }
})();

module.exports = SpecialistsActions;



// WEBPACK FOOTER //
// ./src/common/modules/specialists/actions/specialists.js